<script>
    import Body from './Body.svelte';
</script>

<Body/>
